import React, { useState, useEffect, useMemo } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from "@mui/material";

import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import * as locales from '@mui/material/locale';

function CustomDataGrid(props) {
    const { rows, columns, pageSize, onCellClick, sx, statText, sortBy, page, setPage } = props;
    const [renderedRows, setRenderedRows] = useState([]);

    const theme = useTheme();
    const themeWithLocale = useMemo(
        () => createTheme(theme, locales['esES']),
        [theme],
    );

    useEffect(() => {
        let sortedRows = [],
            r = [],
            n = page * pageSize,
            i = 0,
            getter = (value, row) => value;
        if (sortBy.field)
            for (let c of columns)
                if (c.field === sortBy.field) {
                    getter = c.valueGetter || ((value, row) => value);
                    break;
                }

        for (i = 0; i < rows.length; i++) {
            let index = i;
            if (sortBy.field) index = getter(rows[i][sortBy.field] || '', rows[i]);
            if (typeof index === 'object') index = rows[i][sortBy.field];
            if (typeof index === 'string') index = index.toLowerCase();
            sortedRows.push([index, rows[i]]);
        }
        sortedRows.sort();
        if (sortBy.ord === 'desc') sortedRows.reverse();

        if (sortedRows.length)
            while (r.length < pageSize && n < sortedRows.length)
                r.push(sortedRows[n++][1]);
        setRenderedRows(r);
    }, [rows, pageSize, page, sortBy])

    return (
        <Box>
            <Box sx={{ width: '100%', overflow: 'auto', display: 'block', ...sx }}>
                <Table className="CustomDataGrid">
                    <TableHead>
                        <TableRow>
                            {columns.map((col, index) =>
                                <TableCell
                                    key={'TableHeader-' + col.field}
                                    sx={{ px: 0, position: 'relative' }}
                                    onClick={(e) => onCellClick({
                                        header: true,
                                        field: col.field,
                                        value: (col.headerName || ''),
                                    })}
                                >
                                    <Box sx={{
                                        px: 2,
                                        py: .25,
                                        borderRight: (index < columns.length - 1) ? '2px solid #eee' : 'none',
                                        width: col.width || 'unset',
                                        textAlign: col.headerAlign || 'unset',
                                        minWidth: 'fit-content',
                                        minHeight: '2em'
                                    }}>
                                        {col.headerName || ''}
                                    </Box>
                                    {col.field === sortBy.field ? (
                                        <Box sx={{
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            bottom: 0,
                                            px: .5,
                                            py: 2,
                                            fontSize: 20
                                        }}>
                                            {sortBy.ord === 'asc' ? '↓' : '↑'}
                                        </Box>
                                    ) : ''}
                                </TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {renderedRows.map((row, index) => <TableRow key={'TableRow-' + row.mid}>
                            {columns.map((col, index) => {
                                let value = col.valueGetter ? col.valueGetter(row[col.field] || '', row) : row[col.field] || '',
                                    title = col.titleGetter ? col.titleGetter(row[col.field] || '', row) : value;

                                return (<TableCell
                                    key={'TableCell-' + row.mid + col.field}
                                    sx={{
                                        py: 2,
                                        px: 0,
                                    }}
                                    onClick={(e) => onCellClick({
                                        id: row.mid,
                                        field: col.field,
                                        row: row,
                                    })}
                                >
                                    <Box
                                        sx={{
                                            width: col.width || 'unset',
                                            textAlign: col.align || 'unset',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            px: 1,
                                        }}
                                        data-field={col.field}
                                        title={title}
                                    >
                                        {value}
                                    </Box>
                                </TableCell>)
                            })
                            }


                        </TableRow>)}
                    </TableBody>
                </Table>
            </ Box>
            <Box
                sx={{
                    p: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Box sx={{ px: 2 }}>{statText}</Box>
                <ThemeProvider theme={themeWithLocale}>
                    <TablePagination
                        component="div"
                        count={rows.length || 0}
                        page={page}
                        onPageChange={(event, newPage) => setPage(newPage)}
                        rowsPerPage={pageSize}
                        rowsPerPageOptions={[pageSize]}

                    />
                </ThemeProvider>
            </Box>
        </Box>
    )
}

export default CustomDataGrid;